import { render, staticRenderFns } from "./PicksUp.vue?vue&type=template&id=748db7e1&scoped=true&"
import script from "./PicksUp.vue?vue&type=script&lang=js&"
export * from "./PicksUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748db7e1",
  null
  
)

export default component.exports